(function() {
  'use strict';

  // Prevents the script from running if the element is already defined
  if (customElements.get('quantity-counter')) {
    console.log('QuantityCounter: Already defined, skipping re-definition.');
    return;
  }

  class QuantityCounter extends HTMLElement {
    constructor() {
      super();
      console.log('QuantityCounter: constructor() called. Element created in memory.', this);
    }

    connectedCallback() {
      console.log('QuantityCounter: connectedCallback() called. Element attached to DOM.', this);
      this.input = this.querySelector('input');

      if (!this.input) {
        console.error('QuantityCounter: Could not find an input element inside.', this);
        return;
      }

      this.changeEvent = new Event('change', { bubbles: true });
      this.buttonClickEvent = this.onButtonClick.bind(this);
      this.onQuantityChangeEvent = this.onQuantityChange.bind(this);

      this.input.addEventListener('change', this.onQuantityChangeEvent);
      this.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', this.buttonClickEvent);
      });

      console.log('QuantityCounter: Event listeners attached.', this);
    }

    disconnectedCallback() {
      // This component was removed from the DOM.
      console.warn('QuantityCounter: disconnectedCallback() called. Element removed from DOM.', this);
    }

    onButtonClick(event) {
      event.preventDefault();
      console.log('QuantityCounter: Button clicked.', event.target);

      const originalValue = this.input.value;
      const button = event.target.nodeName === 'BUTTON' ? event.target : event.target.closest('button');

      if (button.name === 'increase') {
        this.input.stepUp();
      } else if (button.name === 'decrease') {
        this.input.stepDown();
      }

      if (originalValue !== this.input.value) {
        console.log(`QuantityCounter: Value changed from ${originalValue} to ${this.input.value}. Dispatching change event.`);
        // this.input.dispatchEvent(this.changeEvent); // <-- Temporarily comment this line out
      }
    }

    onQuantityChange() {
      console.log('QuantityCounter: onQuantityChange() triggered.');
      // if (this.input.name === 'updates[]') {
      //   this.updateCart();
      // }
    }

    updateCart() {
      if (this.input.value !== '') {
        console.log(`QuantityCounter: updateCart() called. Dispatching theme:cart:update for id ${this.input.dataset.id} with quantity ${this.input.value}.`);
        this.dispatchEvent(new CustomEvent('theme:cart:update', {
          bubbles: true,
          detail: {
            id: this.input.dataset.id,
            quantity: this.input.value
          }
        }));
      }
    }
  }

  customElements.define('quantity-counter', QuantityCounter);
  console.log('QuantityCounter: Custom element "quantity-counter" defined.');

})();
